/* global $ */

$(window).one('resize', () => $('html').addClass('was-resized'));
